// GoogleSignIn.web.kt
package app.smartcoding.realrate.platform

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import app.smartcoding.realrate.domain.model.AuthUser
import dev.gitlive.firebase.auth.externals.GoogleAuthProvider
import dev.gitlive.firebase.auth.externals.getAuth
import dev.gitlive.firebase.auth.externals.signInWithPopup
import kotlinx.coroutines.await

private const val TAG = "GoogleSignIn.web"

@Composable
actual fun SignIn(
    authenticationAccount: Boolean,
    onSuccess: (user: AuthUser) -> Unit,
    onFailure: (Throwable) -> Unit
) {
    LaunchedEffect(Unit) {
        try {
            val provider = GoogleAuthProvider()
            val webAuth = getAuth()
            val userCredential = signInWithPopup(webAuth, provider).await()
            val user = userCredential.user
            onSuccess(
                AuthUser.User(
                    displayName = user.displayName,
                    email = user.email,
                    photoUrl = user.photoURL,
                    uid = user.uid
                )
            )
        } catch (e: Throwable) {
            console.error("$TAG: SignIn error with Google", e)
            onFailure(e)
        }
    }
}